import React from 'react'

type P = {
    title?: string;
    description?: string;
    icon?: React.ReactNode;
    children?: React.ReactNode
}

const EmptyState = ({title, description, icon, children}:P) => {
  return (
    <div className='border rounded-md px-16 py-12 w-full flex flex-col gap-6 items-center justify-center bg-white'>
        {icon && <div className='w-16 h-16 min-w-16 min-h-16 border rounded-md bg-white flex items-center justify-center'>{icon}</div>}
        {(title || description) && <div className='flex flex-col max-w-xs gap-2'>
            {title && <p className='mx-auto text-center text-neutral-800 font-medium'>{title}</p>}
            {description && <p className='mx-auto text-center text-neutral-600 text-sm'>{description}</p>}
        </div>}
        {children}
    </div>
  )
}

export default EmptyState